<!-- <div class="spinner-border loader alfalaval-blue-color spinner-center" *ngIf="showSpinner"></div> -->
<h3>AI Search</h3>

<div class="search-container" style="margin-bottom: 20px;">
  <div class="row">
    <div>
      Query syntax:
      <ul>
        <li>Use double quotes for exact phrases, e.g., "stainless steel"</li>
        <li>Use + (AND) for required terms, e.g., +stainless +steel</li>
        <li>Use - (NOT) for excluded terms, e.g., -stainless -KOLDING</li>
        <li>Use | (OR) for boolean OR operations, e.g., stainless | steel (OR is default)</li>
        <li>Grouping with parentheses: +(azure | microsoft) +search (Must contain search and must contain either azure or microsoft) </li>
        <li>Prefix search (starts-with), e.g., stain*</li>
      </ul>
    </div>
    <div class="col-md-8">
      <input
        type="text"
        class="form-control"
        placeholder="Enter search query..."
        [(ngModel)]="searchQuery"
        (keyup.enter)="onSearch()" />
      </div>
      <div class="col-md-4">
        <button class="btn btn-primary" (click)="onSearch()">Search</button>
        <div class="form-check" style="margin-top: 10px;">
          <input
            type="checkbox"
            class="form-check-input"
            id="taxonomySearchCheckbox"
            [(ngModel)]="taxonomySearch" />
            <label class="form-check-label" for="taxonomySearchCheckbox">
              Taxonomy Search
            </label>
          </div>
          @if (taxonomySearch) {
            <div style="margin-top: 10px;">
              <input
                type="text"
                class="form-control form-control-sm"
                placeholder="Enter taxonomy search text..."
                [(ngModel)]="taxonomySearchText"
                (keyup.enter)="onSearch()" />
              </div>
            }
          </div>
        </div>
      </div>

      @if (error) {
        <div class="alert alert-danger" role="alert">
          {{ errorMessage }}
        </div>
      }

      @if (!showSpinner && !error) {
        <div style="width: 100%;">
          <app-pagination-controls
            [totalRows]="this.pagination.totalRows"
            [(currentPage)]="this.pagination.currentPage"
            [pageSize]="this.pagination.pageSize"
            (currentPageChange)="this.pagination.onPageChange($event)"
            (currentPageSize)="this.pagination.OnPageSizeChange($event)" />
            <div class="ag-theme-balham" style="width: 100%;">
              <table class="table table-bordered table-hover" style="width: 100%; margin-bottom: 10;">
                <thead style="background-color: #f8f9fa;">
                  <tr>
                    <th style="width: 50px;"></th>
                    <th style="width: 120px;">Item ID</th>
                    <th style="width: 250px;">Description</th>
                    <th style="width: 300px;">Detailed Description</th>
                    <th style="width: 150px;">Item State</th>
                    <th style="width: 200px;">Item State Description</th>
                    <th style="width: 150px;">ALSIS Product Code</th>
                    <th style="width: 120px;">ALSIS Scope</th>
                    <th style="width: 180px;">Lifecycle Management Status</th>
                    <th style="width: 220px;">Lifecycle Management Status Description</th>
                    <th style="width: 150px;">Origin Source</th>
                    <th style="width: 150px;">Publishing Source</th>
                  </tr>
                  <tr>
                    <th></th>
                    <th><input type="text" class="form-control form-control-sm" [(ngModel)]="filters.itemId" (blur)="onSearch()" placeholder="Filter..." /></th>
                    <th><input type="text" class="form-control form-control-sm" [(ngModel)]="filters.description" (blur)="onSearch()" placeholder="Filter..." /></th>
                    <th><input type="text" class="form-control form-control-sm" [(ngModel)]="filters.detailedDescription" (blur)="onSearch()" placeholder="Filter..." /></th>
                    <th><input type="text" class="form-control form-control-sm" [(ngModel)]="filters.itemState" (blur)="onSearch()" placeholder="Filter..." /></th>
                    <th><input type="text" class="form-control form-control-sm" [(ngModel)]="filters.itemStateDescription" (blur)="onSearch()" placeholder="Filter..." /></th>
                    <th><input type="text" class="form-control form-control-sm" [(ngModel)]="filters.alsisProductCode" (blur)="onSearch()" placeholder="Filter..." /></th>
                    <th><input type="text" class="form-control form-control-sm" [(ngModel)]="filters.alsisScope" (blur)="onSearch()" placeholder="Filter..." /></th>
                    <th><input type="text" class="form-control form-control-sm" [(ngModel)]="filters.lifecycleManagementStatus" (blur)="onSearch()" placeholder="Filter..." /></th>
                    <th><input type="text" class="form-control form-control-sm" [(ngModel)]="filters.lifecycleManagementStatusDescription" (blur)="onSearch()" placeholder="Filter..." /></th>
                    <th><input type="text" class="form-control form-control-sm" [(ngModel)]="filters.originSource" (blur)="onSearch()" placeholder="Filter..." /></th>
                    <th><input type="text" class="form-control form-control-sm" [(ngModel)]="filters.publishingSource" (blur)="onSearch()" placeholder="Filter..." /></th>
                  </tr>
                </thead>
                <tbody>
                  @if (rowDefs.length > 0) {
                    @for (item of rowDefs; track item; let i = $index) {
                      <tr style="cursor: pointer;" (click)="toggleRow(i)">
                        <td style="text-align: center; vertical-align: middle;">
                          @if (item.suppliers && item.suppliers.length > 0) {
                            <span>
                              @if (!item.expanded) {
                                <span>▶</span>
                              }
                              @if (item.expanded) {
                                <span>▼</span>
                              }
                            </span>
                          }
                        </td>
                        <td style="vertical-align: middle;">{{ item.itemId }}</td>
                        <td style="vertical-align: middle;">{{ item.description }}</td>
                        <td style="vertical-align: middle;">{{ item.detailedDescription }}</td>
                        <td style="vertical-align: middle;">{{ item.itemState }}</td>
                        <td style="vertical-align: middle;">{{ item.itemStateDescription }}</td>
                        <td style="vertical-align: middle;">{{ item.alsisProductCode }}</td>
                        <td style="vertical-align: middle;">{{ item.alsisScope }}</td>
                        <td style="vertical-align: middle;">{{ item.lifecycleManagementStatus }}</td>
                        <td style="vertical-align: middle;">{{ item.lifecycleManagementStatusDescription }}</td>
                        <td style="vertical-align: middle;">{{ item.originSource }}</td>
                        <td style="vertical-align: middle;">{{ item.publishingSource }}</td>
                      </tr>
                      @if (item.expanded && item.suppliers && item.suppliers.length > 0) {
                        <tr>
                          <td colspan="12" style="background-color: #f8f9fa; padding: 15px;">
                            <div style="margin-left: 40px;">
                              <h6 style="margin-bottom: 10px; color: #495057;">Suppliers ({{ item.suppliers.length }})</h6>
                              <table class="table table-sm table-bordered" style="background-color: white;">
                                <thead style="background-color: #e9ecef;">
                                  <tr>
                                    <th>Supplier ID</th>
                                    <th>Site ID</th>
                                    <th>Legal Entity</th>
                                    <th>Supplier Item ID</th>
                                    <th>Country Code</th>
                                    <th>Country Name</th>
                                    <th>Net Weight</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  @for (supplier of item.suppliers; track supplier) {
                                    <tr>
                                      <td>{{ supplier.supplierId }}</td>
                                      <td>{{ supplier.siteId }}</td>
                                      <td>{{ supplier.legalEntity }}</td>
                                      <td>{{ supplier.supplierItemIdentification }}</td>
                                      <td>{{ supplier.countryOfOriginCode }}</td>
                                      <td>{{ supplier.countryOfOriginName }}</td>
                                      <td>{{ supplier.netWeight }}</td>
                                    </tr>
                                  }
                                </tbody>
                              </table>
                            </div>
                          </td>
                        </tr>
                      }
                    }
                  }
                  @if (rowDefs.length === 0) {
                    <tr>
                      <td colspan="12" style="text-align: center; padding: 20px;">
                        <span class="text-muted">No results found. Enter a search query and click Search.</span>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        }
